import { MdCall, MdClose } from 'react-icons/md';
import { useVoice } from '../hooks/useVoice';
import styles from './VoiceCallBanner.module.css';

export function VoiceCallBanner() {
  const { availableCalls, incomingCall, callStatus, joinCall, dismissIncomingCall } = useVoice();
  const normalizedCallStatus = callStatus ?? 'idle';
  const normalizedAvailableCalls =
    Array.isArray(availableCalls) && availableCalls.length
      ? availableCalls
      : incomingCall
        ? [incomingCall]
        : [];

  if (normalizedCallStatus !== 'idle' || normalizedAvailableCalls.length === 0) return null;

  return (
    <div className={styles.bannerList}>
      {normalizedAvailableCalls.map(({ roomId, conversationId, roomName, startedBy, createdAt }) => (
        <div key={roomId} className={styles.banner} role="alert" aria-live="polite">
          <MdCall size={16} className={styles.icon} />
          <span className={styles.text}>
            {startedBy ? (
              <>
                <strong>{startedBy}</strong> started a call
                {roomName ? ` · ${roomName}` : ''}
              </>
            ) : (
              <>Active call{roomName ? ` · ${roomName}` : ''}</>
            )}
          </span>
          <div className={styles.actions}>
            <button
              type="button"
              className={styles.joinBtn}
              onClick={() =>
                createdAt != null
                  ? joinCall(roomId, conversationId, createdAt)
                  : joinCall(roomId, conversationId)
              }
              aria-label="Join call"
            >
              <MdCall size={13} /> Join
            </button>
            <button
              type="button"
              className={styles.dismissBtn}
              onClick={() => dismissIncomingCall(roomId)}
              aria-label="Dismiss call notification"
            >
              <MdClose size={13} />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
